import {
  ElementRef,
  Injectable,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { ProfileSelectorFacadeService } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { DashboardResponse } from '@com-delta-idp/mnx-oauth';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoginModalService } from '../../data-access/login-modal/services';
import { LoginDasboardService } from '../../data-access/login-modal/services/login-dasboard.service';
import { LoginHelperUtils } from '../../data-access/utils/login-helper.utils';

@Injectable({
  providedIn: 'root'
})
export class LoginModalWrapperHelperComponent {
  displayLoginModal = false;
  displayProfileSelector = false;
  isOpen = false;
  getDashBrdDataResponse: Partial<DashboardResponse> | undefined;
  warmState$ = new BehaviorSubject<boolean>(false);
  unsubscribe = new Subject<void>();

  constructor(
    protected loginDasboardService: LoginDasboardService,
    protected loginUtilHelper: LoginHelperUtils,
    protected renderer: Renderer2,
    public profileSelectorFacadeService: ProfileSelectorFacadeService,
    protected loginModalService: LoginModalService
  ) {}

  checkForMakingBackendCallForMainApp(
    fromApp: string,
    loginModalDiv: HTMLElement | null,
    shouldcallservice: string
  ) {
    return (
      fromApp &&
      loginModalDiv &&
      !loginModalDiv.classList.contains('d-none') &&
      !shouldcallservice
    );
  }

  checkForTriggerIsFromLoginModal(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes?.shouldcallservice &&
      changes?.shouldcallservice.currentValue === 'true'
    );
  }

  checkForCenterPageLoginModal(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes?.centerpage &&
      changes.centerpage.currentValue === 'true'
    );
  }

  checkForTriggerFromProfileSelector(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes?.fromProfileSelector &&
      changes?.fromProfileSelector?.currentValue === 'true'
    );
  }

  checkForClickFromProfileSelector(
    profileSelectorButton: HTMLElement | null,
    fromprofileselectorValue: string | null | undefined,
    formApp: string
  ): boolean {
    return profileSelectorButton &&
      (fromprofileselectorValue === 'true' || formApp)
      ? true
      : false;
  }

  onCloseProfileModalHelper(profileLoginWrapper: ElementRef) {
    const elementTag: HTMLElement | null = document.querySelector(
      'idp-login-modal-profile-selector'
    );
    const profileSelectorButton = document.querySelector(
      '.account-type'
    ) as HTMLElement;
    elementTag?.setAttribute('fromprofileselector', 'false');
    this.displayProfileSelector = false;
    this.isOpen = false;
    const toggleFlyoutArrow = document.querySelector(
      '.account-type .account-details .toggle-up'
    ) as HTMLElement;
    toggleFlyoutArrow?.classList.replace('toggle-up', 'open-flyout');
    this.renderer.addClass(profileLoginWrapper, 'd-none');
    profileSelectorButton?.focus();
  }

  enableProfileSelector(response: DashboardResponse) {
    this.profileSelectorFacadeService.isLoggedInStatus$.next(
      response.loggedIn || response.isWarmState
    );
    this.profileSelectorFacadeService.isDashBoardResponse$.next(true);
    this.getDashBrdDataResponse = response;
    this.profileSelectorFacadeService.getProfileSelectorContent(
      this.getDashBrdDataResponse
    );
  }

  processLoginModal(changes: SimpleChanges) {
    if (changes.centerPage) {
      this.enableCenterPageLoginModal(changes);
    }
    this.displayLoginModal = true;
    this.displayProfileSelector = false;
  }

  onCloseLoginModalHelper(profileLoginElement: ElementRef) {
    const elementTag: HTMLElement | null = document.querySelector(
      'idp-login-modal-profile-selector'
    );
    this.displayLoginModal = false;
    this.renderer.addClass(profileLoginElement, 'd-none');
    elementTag?.setAttribute('shouldcallservice', 'false');
    elementTag?.setAttribute('centerpage', 'false');
  }

  enableCenterPageLoginModal(changes: SimpleChanges, fromApp?: string) {
    const loginModalDiv = document.querySelector('.login-modal') as HTMLElement;
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      this.renderer.addClass(document.body, 'modal-open');
      loginModalDiv.classList.remove('d-none');
    }

    this.loginModalService.enableCheckOutWarmState(
      fromApp,
      this.warmState$,
      changes
    );
  }
}
